import { Button, Col, Form, Row } from "react-bootstrap";
import WebsiteNavbar from "../Components/WebsiteNavbar/WebsiteNavbar";
import styles from "./about.module.css";
import emailjs from "emailjs-com";
import { useRef, useState } from "react";

export default function About() {
  const formRef = useRef();
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8hen38r",
        "template_bxp6v7l",
        formRef.current,
        "AE2zv3JdfRKTtdKXz"
      )
      .then(
        () => {
          setFeedbackMessage("✅ Message sent successfully!");
          setIsSuccess(true);
          formRef.current.reset();
          setTimeout(() => setFeedbackMessage(""), 4000);
        },
        (error) => {
          setFeedbackMessage("❌ Failed to send message. Please try again.");
          setIsSuccess(false);
          // console.log(error.text);
          setTimeout(() => setFeedbackMessage(""), 4000);
        }
      );
  };

  return (
    <div className={`${styles.about}`}>
      <WebsiteNavbar />

      <div
        className={`${styles["about-landing"]} d-flex align-items-center justify-content-evenly`}
      >
        <div className={`${styles["about-info"]}`} style={{ width: "400px" }}>
          <h1>About US</h1>
          <div className="mb-5">
            Unleashing Potential. Connecting Opportunities.
          </div>
          <p>
            Welcome to TalentSpace, the ultimate platform for discovering,
            nurturing, and investing in talent.
            <br /> Whether you’re a budding artist, an experienced coach, or an
            investor seeking to empower talents, this is where journeys begin,
            and extraordinary potential is realized.
          </p>
        </div>

        <div
          className={`${styles["about-form"]} d-flex align-items-center justify-content-center`}
        >
          <div className={`${styles["form-container"]}`}>
            <div className={`${styles["form-info"]} text-center`}>
              <h6 className={`text-start`}>Get in touch With</h6>
              <h1 className={`${styles.title} mb-3`}>
                <span style={{ color: "#7939FF" }}>Talent</span>Space
              </h1>
              <p>Contact Us For Help You</p>
            </div>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridName">
                  <Form.Control
                    name="name"
                    type="text"
                    placeholder="Full Name"
                    required
                    style={{
                      height: "45px",
                      border: "1px solid rgba(0, 0, 0, 70%)",
                      borderRadius: "12px",
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} controlId="formGridEmail">
                  <Form.Control
                    name="email"
                    type="email"
                    placeholder="Email"
                    required
                    style={{
                      height: "45px",
                      border: "1px solid rgba(0, 0, 0, 70%)",
                      borderRadius: "12px",
                    }}
                  />
                </Form.Group>
              </Row>

              <Form.Group className="mb-3" controlId="formMessage">
                <Form.Control
                  name="message"
                  as="textarea"
                  rows={8}
                  required
                  placeholder="Message"
                  style={{
                    border: "1px solid rgba(0, 0, 0, 70%)",
                    borderRadius: "12px",
                  }}
                />
              </Form.Group>

              <Button
                className="mt-2"
                style={{ borderRadius: "12px" }}
                type="submit"
              >
                Submit
              </Button>
            </Form>
            {feedbackMessage && (
              <div
                style={{
                  marginTop: "10px",
                  padding: "10px",
                  borderRadius: "8px",
                  backgroundColor: isSuccess ? "#d4edda" : "#f8d7da",
                  color: isSuccess ? "#155724" : "#721c24",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {feedbackMessage}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
